import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="footer-section">
            <div className="map-pattern" />
            <div className="footer-wrapper">
                <div className="container">
                    <div className="row gy-lg-0 gy-4">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget">
                                <a href="/" className="footer-logo"><img src="assets/img/logo.png" alt="logo" /></a>
                                <p>At <span style={{ color: '#0A0909', fontWeight: 'bold' }}>TITA Technologies</span>, we are committed to excellence in technology solutions. Our team excels in delivering cutting-edge innovations and seamless integration, ensuring optimal performance and client satisfaction.</p>
                                <ul className="social-share">
                                    <li><a href="https://www.facebook.com/share/15nNHb6u7n/?mibextid=wwXIfr" target="_blank"><i className="fa-brands fa-facebook-f" /></a></li>
                                    <li><a href="https://wa.me/8667296757?text=Hello%20Tita%20Technologies%2C%20I%20would%20like%20to%20inquire%20about%20your%20services.%20Best%20regards%2C%20[Your%20Name]" target="_blank"><i className="fa-brands fa-whatsapp" /></a></li>
                                    <li><a href="https://www.linkedin.com/company/tita-technologies/" target="_blank"><i className="fa-brands fa-linkedin" /></a></li>
                                    <li><a href="https://www.instagram.com/tita_technologies_global/profilecard/?igsh=MThwcTc4dGw1ZXp3MA== " target="_blank"><i className="fa-brands fa-instagram" /></a></li>
                                    <li><a href="https://x.com/tita_global?s=11" target="_blank"><i class="fa-brands fa-x-twitter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget widget-links">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul className="footer-links">
                                    <li><Link to="/about" >About Us</Link></li>
                                    <li><Link to="/contact" >Contact</Link></li>
                                    <li><Link to="/service" >IT Solutions</Link></li>
                                    <li><Link to="/careers" >Careers</Link></li>
                                    <li><Link to="/terms_and_conditions" >Terms & Conditions</Link></li>
                                    <li><Link to="/cancellation_and_refundpolicy" >Cancellation & Refund Policy</Link></li>


                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget">
                                <div className="widget-title">
                                    <h3>Get In Touch</h3>
                                </div>
                                <ul className="footer-contact-info">
                                    <li>
                                        <p><span>Headquarters:</span> No 81,Rajaram street, jawahar nagar,Thirumangalam-625706</p>
                                    </li>
                                    <li>
                                        <p><span>Regional Office:</span> Toronto, Canada</p>
                                    </li>
                                    <li>
                                        <p><span>Phone:</span><b>India :</b> +91 86672 - 96757</p>
                                        <p><b>Canada :</b> +1 647-988-7328</p>
                                    </li>
                                    <li>
                                        <p><span>Mail:</span>contact@titatechnologies.com</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col-lg-3 col-md-6">
                            <div className="footer-widget">
                                <div className="widget-title">
                                    <h3>News Letter</h3>
                                </div>
                                <form  className="subscribe-form" noValidate="true">
                                    <div className="mc-fields">
                                        <input className="form-control" type="email" name="EMAIL" placeholder="Your Email Address" required />
                                        <input type="hidden" name="action" defaultValue="mailchimpsubscribe" />
                                        <button className="submit">Sign Up</button>
                                    </div>
                                    <div className="clearfix" />
                                    <div id="subscribe-result">
                                        <div className="subscription-success" />
                                        <div className="subscription-error" />
                                    </div>
                                </form>
                            </div>
                        </div> */}
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget">
                                <div className="widget-title">
                                    <h3>Way to iTrain &nbsp;&nbsp;  ( LMS )</h3>
                                </div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <img src="assets/img/qr-code.png"  ></img></div>
                            </div></div>
                    </div>
                </div>

            </div>
            <div className="copyright-area">
                © TITA Technologies Inc.
            </div>
        </footer>
    );
};

export default Footer;
